/**
 * @desc: - 面板- 下拉带文字链接
 * @param  {[STRING]} className     [顶层样式类]
 * @param  {[ARRAY]}  displaySet    [导航类名集合] - [{url: '', text: ''}]
 * @author: klaf
 */
import React from 'react';

export default class DropDownTextList extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {childMenus} = this.props;
    var childNavs = childMenus.map((row, index) => {
      return <p key={index}>
        <a href={row.url}>{row.text}</a>
      </p>
    })

    return (
      <div className="nav_child nav_child_text">
        {childNavs}
      </div>
    );
  }
}
